import { Link } from 'react-router-dom';
import { GAME_CREATION_STEPS } from '../gameCreationPath';

export default function GameCreationPathPage() {
  return (
    <div className="oge-path-page">
      <div className="page-header">
        <h1>Создание игр</h1>
        <p className="page-subtitle">
          Иди сверху вниз. В каждом шаге сначала конспект, потом практика на холсте.
        </p>
      </div>

      <ol className="oge-path-list">
        {GAME_CREATION_STEPS.map((step, index) => (
          <li key={step.id} id={`shag-${step.id}`} className="oge-path-step">
            <div className="oge-path-step-num" aria-hidden>
              {index + 1}
            </div>
            <div className="oge-path-step-body">
              <h2 className="oge-path-step-title">{step.title}</h2>
              {step.lead ? (
                <p className="oge-path-step-lead text-secondary">{step.lead}</p>
              ) : null}
              <ol className="oge-path-actions">
                {step.konspekts.map((k) => (
                  <li key={k.slug}>
                    <span className="oge-path-kind">Прочитать</span>
                    <Link to={`/konspekty/${k.slug}`}>{k.title}</Link>
                  </li>
                ))}
                {step.practiceHref ? (
                  <li>
                    <span className="oge-path-kind">Практика</span>
                    <Link to={step.practiceHref}>{step.practiceLabel}</Link>
                  </li>
                ) : null}
              </ol>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
